<template>
  <div class="content-item flex">
    <div class="content-item-label"><span class="red">*</span>是否传染病</div>
    <el-radio-group v-model="radio" class="flex align-items-center">
      <el-radio :label="1">是</el-radio>
      <el-radio :label="0">否</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "InfectiousMark",
  props: ['infectiousMark'],
  computed: {
    radio: {
      get() {
        return this.infectiousMark
      },
      set(val) {
        this.$emit('update:infectiousMark',val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
